<template>
  <div>
    <el-form class="mt8"
      label-width="120px"
      label-position="left"
      hide-required-asterisk
      @submit.native.prevent
      :model="form"
      ref="form">
      <el-form-item label-width="0">
        <span class="text-placeholder">设置手机和邮箱,可让你在忘记密码时更快找回</span>
      </el-form-item>

      <el-form-item label="手机：">
        <div v-if="form.telephone" 
        class="content">
          <span>{{form.telephone | encryptPhone}}</span>
          <zt-button size="medium"
            @click="openDialog('modifyPhone')">修改</zt-button>
        </div>
        <div v-else 
        class="content">
          <span class="text-placeholder">您未绑定手机</span>
          <zt-button size="medium">绑定</zt-button>
        </div>
      </el-form-item>

      <!-- <el-form-item label="邮箱：">
        <div v-if="form.email" class="content">
          <span>{{form.email}}【已验证】</span>
          <zt-button size="medium" @click="onModifyEmail">修改</zt-button>
        </div>
        <div v-else class="content">
          <span class="text-placeholder">您未绑定邮箱</span>
          <zt-button size="medium">绑定</zt-button>
        </div>
      </el-form-item> -->

      <el-form-item label="登录密码：">
        <div class="content">
          <span v-if="pwdNotChangeDay > 365"
            class="text-warning">您的登录密码已经{{pwdNotChangeDay}}天未更改</span>
          <span v-else>***************</span>
          <zt-button size="medium"
            @click="openDialog('modifyPwd')">修改</zt-button>
        </div>
      </el-form-item>
    </el-form>

    <modify-phone :visible.sync="dialogVisible.modifyPhone"
      width="460px"
      title="修改手机号码"
      :close-on-click-modal="false"
      @close="closeDialog('modifyPhone')"></modify-phone>

    <modify-pwd :visible="dialogVisible.modifyPwd"
      width="460px"
      title="修改密码"
      @close="closeDialog('modifyPwd')"
      :submit="submitPwd"></modify-pwd>

    <!-- <modify-email
      :visible="dialogVisible.modifyEmail"
      width="460px"
      title="修改邮箱"
      @close="dialogVisible.modifyEmail = false"
      :submit="submitEmail"
      :emailErr="''"
    ></modify-email> -->
  </div>
</template>

<script>
import modifyPhone from './components/modifyPhone'
import modifyPwd from './components/modifyPwd'
import { limitObject } from '@/utils'
import dayjs from 'dayjs'
import { encryptPhone } from '@/filters/encrypt'

export default {
  name: 'myCenterSafe',
  components: {
    modifyPhone,
    modifyPwd,
  },
  filters: {
    encryptPhone,
  },
  computed: {
    'pwdNotChangeDay'() {
      return dayjs().diff(dayjs(this.form.password_updatetime * 1000), 'days')
    },
  },
  data: () => ({
    form: {
      telephone: null,
      password_updatetime: '',
    },
    smsErr: '',
    dialogVisible: {
      modifyPhone: false,
      modifyEmail: false,
      modifyPwd: false,
    },
  }),
  created() {
    this.getInfo()
  },
  methods: {
    // 获取信息
    getInfo() {
      var info = limitObject(this.$store.getters.user_info, ['telephone', 'password_updatetime'], true);
      this.form = info;
      console.log('获取信息', this.form);

    },


    // 提交 - 修改密码
    submitPwd() {

    },

    openDialog(key) {
      this.dialogVisible[key] = true
    },

    closeDialog(key) {
      this.dialogVisible[key] = false
    },

  },
}
</script>

<style lang="scss" scoped>
.text-warning {
  color: $theme-orange;
}
.text-placeholder {
  color: $theme-textplaceholder;
}
.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .zt-button {
    margin-right: 30px;
  }
}
</style>